import { theme } from "@repo/ui";
import { NORTH_AMERICA, EUROPE_ASIA } from "@repo/utils";

export const contentLayoutConfig: {
  [key: string]: {
    leftColumn: number;
    maxWidth: number;
    rightColumn: number;
  };
} = {
  [NORTH_AMERICA]: {
    leftColumn: 4.8,
    maxWidth: theme.breakpoints.values.lg,
    rightColumn: 7.2,
  },
  [EUROPE_ASIA]: {
    leftColumn: 6,
    maxWidth: 970,
    rightColumn: 6,
  },
};
